(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bg-season-flowers-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (root) => {
  if(root.dataset.carouselReady)return;
  root.dataset.carouselReady='true';
  const gallery=root.querySelector('.bg-flowers__gallery');
  const slides=[...gallery.querySelectorAll('figure')];
  if(slides.length<2)return;
  const controls=root.querySelector('.bg-flowers__controls');
  const dots=[...root.querySelectorAll('[data-flower-dot]')];
  const pause=root.querySelector('[data-flower-pause]');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let index=0,timer,paused=false,hover=false,focused=false,visible=false;
  controls.hidden=false;
  function stop(){clearInterval(timer);timer=null;}
  function start(){stop();if(!paused&&!hover&&!focused&&visible&&!document.hidden&&!reduced.matches)timer=setInterval(()=>go(index+1),5500);}
  function go(next){index=(next+slides.length)%slides.length;gallery.scrollTo({left:slides[index].offsetLeft-gallery.offsetLeft-(gallery.clientWidth-slides[index].clientWidth)/2,behavior:reduced.matches?'instant':'smooth'});dots.forEach((d,i)=>i===index?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'));}
  root.querySelector('[data-flower-prev]').addEventListener('click',()=>{go(index-1);start();});
  root.querySelector('[data-flower-next]').addEventListener('click',()=>{go(index+1);start();});
  dots.forEach((d,i)=>d.addEventListener('click',()=>{go(i);start();}));
  pause.addEventListener('click',()=>{paused=!paused;pause.textContent=paused?'Reanudar':'Pausar';pause.setAttribute('aria-pressed',String(paused));start();});
  gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));start();}});
  gallery.addEventListener('scroll',()=>{const center=gallery.getBoundingClientRect().left+gallery.clientWidth/2;let closest=Infinity;slides.forEach((s,i)=>{const rect=s.getBoundingClientRect(),distance=Math.abs(rect.left+rect.width/2-center);if(distance<closest){closest=distance;index=i;}});dots.forEach((d,i)=>i===index?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'));},{passive:true});
  root.addEventListener('mouseenter',()=>{hover=true;stop();});root.addEventListener('mouseleave',()=>{hover=false;start();});
  root.addEventListener('focusin',()=>{focused=true;stop();});root.addEventListener('focusout',()=>{setTimeout(()=>{focused=root.contains(document.activeElement);start();},0);});
  gallery.addEventListener('touchstart',stop,{passive:true});gallery.addEventListener('touchend',start,{passive:true});
  document.addEventListener('visibilitychange',start);reduced.addEventListener('change',start);
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;start();},{threshold:.25}).observe(root);
 };
 document.querySelectorAll('[data-flower-carousel]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-flower-carousel]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
